import { Configuration } from '@/types/configuration';

export const configurationMapper = (data: Configuration): Configuration => ({
  miriamTypes: data.miriamTypes,
  version: data.version,
  buildDate: data.buildDate,
  gitHash: data.gitHash,
  options: data.options,
  mapFormats: data.mapFormats,
  imageFormats: data.imageFormats,

  // annotators: data.annotators,
  // elementTypes: data.elementTypes,
  // modelConverters: data.modelFormats,
  // modificationStateTypes: data.modificationStateTypes,
  // options: data.options,
  // overlayTypes: data.overlayTypes,
  // privilegeTypes: data.privilegeTypes,
  // reactionTypes: data.reactionTypes,
});
